import React from "react";
import { Typography, Box } from "@material-ui/core";
import { ApiResponseLogCategory } from "generated/graphql";
import { DPPermissionGate, DPSpacer } from "Components/DP";
import useDirectDepositFiles from "./Hooks/useDirectDepositFiles";
import ApiResponseLogTable from "../ApiResponseLogTable/ApiResponseLogTable";
import DirectDepositTable from "./DirectDepositTable/DirectDepositTable";
import DirectDepositUpdateButton from "./DirectDepositUpdateButton/DirectDepositUpdateButton";

export const DirectDepositUpdatePageContent = () => {
  const {
    data,
    loading,
    page,
    setPage,
    rowsPerPage,
    pendingCount,
    refetch,
  } = useDirectDepositFiles();

  return (
    <>
      <DPPermissionGate permissionKeys={["canDownloadDirectDepositUpdates"]}>
        <Box pb={1}>
          <DirectDepositUpdateButton
            refetch={refetch}
            pendingCount={pendingCount}
          />
        </Box>
      </DPPermissionGate>
      <DPPermissionGate permissionKeys={["canViewPendingUpdateCount"]}>
        <Typography
          id={"pending-count"}
          color={pendingCount ? "error" : "inherit"}
        >
          {pendingCount} pending {pendingCount === 1 ? "update" : "updates"}
        </Typography>
        <DPSpacer spacing={3} />
      </DPPermissionGate>
      <Typography variant={"h2"}>File Downloads</Typography>
      {data && (
        <DirectDepositTable
          loading={loading}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          page={page}
          {...data}
        />
      )}

      <ApiResponseLogTable
        logCategory={ApiResponseLogCategory.DirectDepositUpdates}
        title="API Log (POST /users/{user_id}/direct_deposit)"
      />
    </>
  );
};
